"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPayload = void 0;

var _PayloadActions = require("../actions/PayloadActions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _PayloadAPI = _interopRequireDefault(require("../api/PayloadAPI"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _requestStatuses = require("../selectors/requestStatuses");

var fetchPayload = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _PayloadAPI.default.getPayload,
  initiatingActionType: _PayloadActions.PayloadActionTypes.LOAD_PAYLOAD,
  requestStatusSelector: _requestStatuses.getFetchPayloadRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _PayloadActions.FetchPayload
}));
exports.fetchPayload = fetchPayload;